window.BAO.geoLocationPromise = window.BAO.Utils.fetchJSON(
  '/browsing_context_suggestions.json',
  {
    method: 'GET',
  },
)
  .then((res) => {
    const countryCode = res.detected_values.country.handle

    window.theme = window.theme || {}
    window.theme.customer = window.theme.customer || {}

    window.theme.customer.countryCode = countryCode
  })
  .catch((err) => {
    console.error('Browsing context request failed:', err)
    throw err
  })
